export type InventoryQuotationStatus = 'draft' | 'cancelled'

export type InventoryQuotationLine = {
  /** Stable client id for React keys */
  lineKey: string
  /** Set when line was loaded from API — sent as line `id` on Update */
  serverLineId?: number
  itemId: string
  batchId: string
  availableQuantity: number
  quantity: number
  unitPrice: number
  discountPercent: number
  taxRateId: string
}

export type InventoryQuotation = {
  id: string
  branchId: number
  code: string
  reference: string
  customerId: string
  customerName: string
  warehouseId: string
  warehouseName: string
  paymentMethodId: string
  paymentTermId: string
  orderDate: string
  estDeliveryDate: string
  attachmentName?: string
  /** Legacy header discount; always 0 — line % discounts are the source of truth. */
  orderDiscount: number
  lines: InventoryQuotationLine[]
  status: InventoryQuotationStatus
  createdAt: string
  updatedAt: string
}

export const newQuotationLine = (): InventoryQuotationLine => ({
  lineKey: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `ln-${Date.now()}-${Math.random()}`,
  itemId: '',
  batchId: '',
  availableQuantity: 0,
  quantity: 0,
  unitPrice: 0,
  discountPercent: 0,
  taxRateId: '',
})

export const lineGrossAmount = (l: InventoryQuotationLine) => {
  const qty = Number(l.quantity || 0)
  const price = Number(l.unitPrice || 0)
  return Math.max(0, qty * price)
}

/** Currency discount from line % (same rule as purchase order lines). */
export const lineDiscountAmount = (l: InventoryQuotationLine) => {
  const gross = lineGrossAmount(l)
  const discountPct = Number(l.discountPercent || 0)
  return gross * (discountPct / 100)
}

export const lineTaxableAmount = (l: InventoryQuotationLine) => {
  const gross = lineGrossAmount(l)
  const discountPct = Number(l.discountPercent || 0)
  return Math.max(0, gross * (1 - discountPct / 100))
}
